import { Injectable } from '@angular/core';
import { PlatformLocation } from '@angular/common';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { DialogConfig, DialogRef } from '@angular/cdk/dialog';
import { PatientAppPopUpComponent } from '@modules/patient/components/patient-app-popup/patient-app-popup.component';
import { PatientAppPupupInput } from '@modules/patient/models/patient-app-pupup-input';
import { ConfirmationPopUpComponent } from '@shared/components/confirmation-pop-up/confirmation-pop-up.component';
import { ConfirmationPopUpInput } from '@shared/models/confirmation-pop-up-input';
import { PopUpActions } from '@shared/models/enums/popup-modal-actions.enum';
import { Observable } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class PopupService {

	constructor(
		private readonly dialog: TlkModalWindowService,
		private location: PlatformLocation
	) { }

	openConfirmationPopUp({ popUpInput }: { popUpInput: ConfirmationPopUpInput }): Observable<PopUpActions> {
		const popup = this.dialog.open<PopUpActions, ConfirmationPopUpInput, ConfirmationPopUpComponent>(ConfirmationPopUpComponent, {
			maxWidth: '720px',
			width: '100%',
			data: popUpInput,
			disableClose: true,
			panelClass: 'confirmation-pop-up'
		});

		this.location.onPopState(() => popup.close());

		return popup.closed.pipe(
			filter((action): action is PopUpActions => action != null),
			tap(popUpAction => {
				if (popUpAction === PopUpActions.Ok && popUpInput.dontShowAgainAction &&
					typeof popUpInput.dontShowAgainAction === 'function' && popup.componentInstance?.dontShowAgain) {
					popUpInput.dontShowAgainAction();
				}
			}));
	}

	openPatientAppPopUp(inputParams: PatientAppPupupInput, config: Partial<DialogConfig> & Record<string, unknown> = {}): DialogRef<void, PatientAppPopUpComponent> {
		const popup = this.dialog.open<void, PatientAppPupupInput, PatientAppPopUpComponent>(PatientAppPopUpComponent, {
			id: 'patient-app-popup',
			maxWidth: '790px',
			width: '100%',
			data: inputParams,
			panelClass: 'patient-app-dialog',
			...config as object,
		});

		this.location.onPopState(() => popup.close());

		return popup;
	}

	isPopupOpenById(popupId: string): boolean {
		return !!this.dialog.getDialogById(popupId);
	}

	closePopUp(){
		this.dialog.closeAll()
	}

}
